const triggerButtons = document.querySelectorAll('[data-trigger="show-hide-trigger"]');
function fadeInOut(element, height, toggleClosed) {
    element.style.height = toggleClosed ? '0px' : height + 'px';
}
if (triggerButtons.length > 0) {
    [...triggerButtons].forEach((section) => {
        const initalState = section.dataset.triggerInitial;
        const parentSection = section.closest('.shopify-section');
        const nextSection = parentSection.nextElementSibling;
        // If the next element is a section, add the initial state class to show/hide the section
        if (nextSection && nextSection.classList.contains('shopify-section')) {
            nextSection.classList.add('section-trigger');
            nextSection.classList.add(`section-trigger--${initalState}`);
            const nextInner = nextSection.firstElementChild;
            nextInner.classList.add('section-trigger__child');
            let currentState = initalState === 'closed';
            // add event listener for to trigger the show/hide functionality of the section
            section.addEventListener('click', () => {
                const nextHeight = nextInner.getBoundingClientRect().height;
                nextSection.classList.toggle('section-trigger--closed');
                window.requestAnimationFrame(() => fadeInOut(nextSection, nextHeight, currentState));
                if (currentState === true) {
                    const elemPos = nextSection.getBoundingClientRect().top + window.scrollY;
                    let scrollYPos = elemPos;
                    if (window.innerWidth <= 767) {
                        scrollYPos = elemPos - 64;
                    }
                    else {
                        scrollYPos = elemPos - 80;
                    }
                    window.scroll({
                        top: scrollYPos,
                        left: 0,
                        behavior: 'smooth',
                    });
                }
                currentState = !currentState;
            });
        }
    });
}
